<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-md-4 col-xl-2">
                    <h4 class="card-title">{{'admin.revenue.updates.selectDates' |lang}}</h4>
                    <div class="form-group">
                        <div class="input-wrap">
                            <input ref="fromDate" id="fromDate" type="text" name="fromDate" value=""
                                   placeholder="Draft" class="form-control" autocomplete="off">
                            <span class="input-focus-border"></span>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-wrap">
                            <input ref="toDate" id="toDate" type="text" name="toDate" value="" placeholder="Draft"
                                   class="form-control" autocomplete="off">
                            <span class="input-focus-border"></span>
                        </div>
                    </div>
                    <button class="btn btn-primary" id="getTheFlow" @click="getFlow()" :disabled="getFlowStarted">
                        {{'admin.revenue.updates.getRevenueInfo' |lang}}
                    </button>
                </div>
                <div class="col-md-8 col-xl-10 mt-3 mt-lg-0">
                    <h4 class="card-title">{{'admin.revenue.updates.revenueInfo' |lang}}</h4>
                    <div class="row mr-2">
                        <div class="col col-sm-4 col-lg-2" data-toggle="tooltip"
                             :title="'admin.revenue.updates.totalTooltip' |lang">{{'admin.revenue.updates.total' |lang}}<span
                                class="highlight-orange">${{total}}</span></div>
                        <div class="col col-sm-4 col-lg-2" data-toggle="tooltip"
                             :title="'admin.revenue.updates.systemTooltip' |lang">{{'admin.revenue.updates.systemTotal'
                            |lang}}<span
                                    class="highlight-orange">${{systemTotal}}</span></div>
                        <div class="col col-sm-4 col-lg-2" data-toggle="tooltip"
                             :title="'admin.revenue.updates.nonSystemTooltip' |lang">
                            {{'admin.revenue.updates.nonSystemTotal' |lang}}<span
                                class="highlight-orange">${{nonSystemTotal}}</span></div>
                        <div class="col col-sm-4 col-lg-2" data-toggle="tooltip"
                             :title="'admin.revenue.updates.departmentTooltip' |lang">
                            {{'admin.revenue.updates.departmentTotal' |lang}}<span
                                class="highlight-orange">${{departmentTotal}}</span></div>
                        <div class="col col-sm-4 col-lg-2" data-toggle="tooltip"
                             :title="'admin.revenue.updates.otherTooltip' |lang">{{'admin.revenue.updates.otherTotal'
                            |lang}}<span
                                    class="highlight-orange">${{otherTotal}}</span></div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col">
                            <h4 class="card-title">{{'admin.revenue.updates.flowInfo' |lang}}</h4>
                            <div class="d-inline-block mr-2">
                                <span>{{'general.system' |lang}}</span>
                                <span class="ion ion-ios-arrow-round-back arrow-medium highlight-white"></span>
                                <span class="highlight-orange">{{systemPercentage}}</span>
                            </div>
                            <div class="d-inline-block mr-2">
                                <span>{{'department.self' |lang}}</span>
                                <span class="ion ion-ios-arrow-round-back arrow-medium highlight-white"></span>
                                <span class="highlight-orange">{{departmentPercentage}}</span>
                            </div>
                            <div class="d-inline-block mr-2">
                                <span>{{'admin.revenue.updates.other' |lang}}</span>
                                <span class="ion ion-ios-arrow-round-back arrow-medium highlight-white"></span>
                                <span class="highlight-orange">{{otherPercentage}}</span>
                            </div>
                            <div class="d-inline-block">
                                <span class="ion ion-logo-youtube youtube-logo text-danger"></span>
                                <span>YouTube</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import flatpickr from 'flatpickr';


  export default {
    name: "RevenueFlow",

    props: {
      route: String,
      fromDate: '',
      toDate: '',
    },
    data() {
      return {
        getFlowStarted: false,
        total: null,
        systemTotal: null,
        nonSystemTotal: null,
        departmentTotal: null,
        otherTotal: null,
      };
    },
    computed: {
      systemPercentage: function () {
        return this.getRatio(this.systemTotal, this.total) + '%';
      },
      departmentPercentage: function () {
        return this.getRatio(this.departmentTotal, this.total) + '%';
      },
      otherPercentage: function () {
        return this.getRatio(this.otherTotal, this.total) + '%';
      },
    },
    methods: {
      getFlow() {
        if (this.getFlowStarted) {
          return;
        }
        this.getFlowStarted = true;
        axios.get(this.route, {
          params: {
            fromDate: this.$refs.fromDate.value,
            toDate: this.$refs.toDate.value
          }
        }).then(response => {
          this.setData(response.data);
          this.getFlowStarted = false;
        }).catch(error => {
          this.getFlowStarted = false;
          console.error(error);
        });
      },

      setData(data) {
        this.total = data.total;
        this.systemTotal = data.systemTotal;
        this.nonSystemTotal = data.nonSystemTotal;
        this.departmentTotal = data.departmentTotal;
        this.otherTotal = data.otherTotal;
      },
      getRatio(part, whole) {
        if (whole <= 0) {
          return 0;
        }
        let x = parseFloat(part);
        let y = parseFloat(whole);
        return ((x / y) * 100).toFixed(2);
      }
    },
    mounted() {
      //set initial value
      this.$refs.fromDate.value = this.fromDate;
      this.$refs.toDate.value = this.toDate;

      flatpickr(this.$refs.fromDate, {
        // enableTime: true,
        dateFormat: 'Y-m-d',// H:i:00
        time_24hr: true,
        minDate: '2017-01-01',
        maxDate: 'today',
      });
      flatpickr(this.$refs.toDate, {
        // enableTime: true,
        dateFormat: 'Y-m-d',// H:i:00
        time_24hr: true,
        minDate: '2017-01-01',
        maxDate: 'today',
      });
      this.getFlow();
    }
  }
</script>

<style scoped>
    .arrow-medium {
        font-size: 40px;
        position: relative;
        top: 10px;
    }

    .youtube-logo {
        font-size: 28px;
        position: relative;
        top: 6px;
    }
</style>